import { createMuiTheme } from '@material-ui/core/styles';
import { dark, green, light, pink, primary } from './colors';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: green,
      contrastText: primary,
    },
    secondary: {
      main: dark,
      contrastText: light,
    },
    error: {
      main: pink,
      contrastText: '#C70000',
    },
  },
  typography: {
    fontFamily: ['Roboto', 'Helvetica Neue', 'sans-serif'].join(','),
    fontSize: 14,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          boxSizing: 'border-box',
        },
      },
    },
  },
});

export default theme;
